<script>
import { mapGetters } from 'vuex';

export default {
  emits: ['toggleAccounts'],
  computed: {
    ...mapGetters({
      account: 'getCurrentAccount',
    }),
    customAttributes() {
      return this.account.custom_attributes || {};
    },
    subscription() {
      return this.account.subscription || {};
    },
    subscriptionStatus() {
      return this.subscription.status || this.customAttributes.subscription_status || '';
    },
    subscriptionEndsOn() {
      return (
        this.subscription.end_date ||
        this.subscription.trial_ends_at ||
        this.customAttributes.subscription_ends_on ||
        ''
      );
    },
    planName() {
      return this.subscription.plan_name || this.customAttributes.plan_name || '';
    },
    isTrial() {
      if (typeof this.subscription.is_trial === 'boolean') {
        return this.subscription.is_trial;
      }
      return this.subscriptionStatus === 'trial';
    },
    isActive() {
      if (typeof this.subscription.is_active === 'boolean') {
        return this.subscription.is_active;
      }
      return this.subscriptionStatus === 'active';
    },
    isExpired() {
      if (typeof this.subscription.is_expired === 'boolean') {
        return this.subscription.is_expired;
      }
      return this.subscriptionStatus === 'expired';
    },
    showSubscriptionStatus() {
      return !!this.subscriptionStatus && !!this.planName;
    },
    daysUntilExpiry() {
      if (this.isTrial) {
        const trialDays = this.subscription.days_until_trial_expiry;
        if (Number.isInteger(trialDays)) {
          return trialDays;
        }
      }

      const expiryDays = this.subscription.days_until_expiry;
      if (Number.isInteger(expiryDays)) {
        return expiryDays;
      }

      if (!this.subscriptionEndsOn) return null;
      const endDate = new Date(this.subscriptionEndsOn);
      const today = new Date();
      const diffTime = endDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    isUnlimited() {
      if (this.subscription.billing_cycle) {
        return this.subscription.billing_cycle === 'unlimited';
      }
      return this.customAttributes.subscription_billing_cycle === 'unlimited';
    },
    timeRemaining() {
      if (this.isUnlimited) return 'Vĩnh viễn - Không hết hạn';
      if (!this.daysUntilExpiry) return null;
      if (this.isExpired) return 'Đã hết hạn';
      if (this.daysUntilExpiry === 1) return '1 ngày còn lại';
      return `${this.daysUntilExpiry} ngày còn lại`;
    },
    statusClass() {
      if (this.isTrial) return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400';
      if (this.isActive) return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400';
      if (this.isExpired) return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400';
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-400';
    },
    statusText() {
      if (this.isTrial) return 'Trial';
      if (this.isActive) return 'Active';
      if (this.isExpired) return 'Expired';
      return this.subscriptionStatus;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div class="px-2 py-1 mt-1 space-y-1">
    <!-- Subscription Status -->
    <div
      v-if="showSubscriptionStatus"
      class="text-xs outline outline-1 outline-n-weak rounded-lg bg-n-solid-3 dark:bg-n-black/30"
    >
      <div class="p-2">
        <div class="flex items-center justify-between mb-1">
          <span class="text-n-slate-11">Subscription</span>
          <span 
            class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium"
            :class="statusClass"
          >
            {{ statusText }}
          </span>
        </div>
        
        <div v-if="planName" class="text-n-slate-12 font-medium mb-1">
          {{ planName }}
        </div>
        
        <div v-if="timeRemaining" class="text-n-slate-10">
          {{ timeRemaining }}
        </div>
        
        <!-- Warning for critical status (skip for unlimited) -->
        <div v-if="!isUnlimited && (isExpired || (daysUntilExpiry !== null && daysUntilExpiry <= 7))" class="mt-2">
          <button
            @click="$router.push('/app/accounts/settings/billing')"
            class="w-full text-xs bg-n-blue-9 hover:bg-n-blue-10 text-white px-2 py-1 rounded"
          >
            {{ isExpired ? 'Nâng cấp' : isTrial ? 'Nâng cấp' : 'Gia hạn' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
